import { render, staticRenderFns } from "./uploadFood.vue?vue&type=template&id=16c981df&scoped=true"
import script from "./uploadFood.vue?vue&type=script&lang=js"
export * from "./uploadFood.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./uploadFood.vue?vue&type=style&index=1&id=16c981df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c981df",
  null
  
)

export default component.exports